<template>
  <div class="box">
    <div class="in-from-ul">
      <div class="in-from-li" :class="{ active: item.readStatus }" v-for="(item, index) in list2" :key="index" @click="onClickRoute(item)">
        <div class="in-from-top">
          <div class="in-from-left">
            <div class="icon">
              <img src="@/assets/images/inform.png" />
            </div>
            <span>{{ item.message.title }}</span>
          </div>
          <div class="in-from-right" v-if="item.message && item.message.createTimeForma != undefined">
            {{ item.message.createTimeFormat }}
          </div>
        </div>
        <div class="in-from-text" v-if="item.message && item.message.title != undefined">
          {{ item.message.content }}
        </div>
      </div>
    </div>
    <el-pagination class="paging" background :current-page="page.number" :page-sizes="[10, 20, 30, 40]" :page-size="page.limit" layout="prev, pager, next, sizes" :total="page.total" @size-change="sizeChange"
      @current-change="currentChange" @prev-click="prevClick" @next-click="nextClick" />
  </div>
</template>

<script>
import { getLiveDetail } from '@/api/home'

export default {
  name: "InProgress",
  props: {
    list2: {
      type: Array,
      default: []
    },
    page: {
      type: Object,
      default: () => {
        return {
          number: 1,
          limit: 10,
          total: 0,
        }
      }
    }
  },
  data() {
    return {
      appPage: {
        NEWS: 'NewsDetails', // 新闻资讯
        COURSE: 'CourseDetails', // 质控课程
        NOTICE: 'QualityControlDetails', // 质控公告
        FORM: '', // 病程上报
        GUIDE_CONSENSUS: 'NewsDetailsThree', // 指南共识
        SCIENCE: 'NewsDetailsTwo', // 科普知识
        SENTINEL_HOSPITAL: 'Recruitment', // 哨点医院
        LIVE: '', // 直播会议
        LIAISON_RECRUITMENT: 'Recruitment2', // 联络员招募
        CENTER_PROFILE: 'CenterProfile', // 中心简介
        QUESTIONNAIRE: '', // 问卷
      }
    }
  },
  methods: {
    onClickRoute(item) {
      if(item.message.targetProps.appPage != undefined) {
        if(this.appPage[item.message.targetProps.appPage] == '' && item.message.targetProps.appPage != "LIVE") {
          return
        }
        if(item.message.targetProps.appPage == "LIVE") {
          if(item.message.skipPage == "NOT") {
            this.$router.push({ path: `/LiveDetail/${item.message.targetProps.appParams.id}` })
          }else {
            this.getLiveDetail(item.message.targetProps.appParams.id)
          }
          return
        }
        this.$router.push({ path: `/${this.appPage[item.message.targetProps.appPage]}/${item.message.targetProps.appParams.id}` });
      }else if(item.message.targetProps.h5Url != undefined){
        window.open(item.message.targetProps.h5Url);
      }
    },
    // 按 id 查询直播管理
    async getLiveDetail(id) {
      await getLiveDetail({
        id: id
      }).then(res => {
        window.open(res.data[0].liveJumpAddress);
      })
    },
    sizeChange(value) {
      this.$emit('sizeChange', value)
    },
    currentChange(value) {
      this.$emit('currentChange', value)
    },
    prevClick(value) {
      this.$emit('currentChange', value)
    },
    nextClick(value) {
      this.$emit('currentChange', value)
    },
  }
};
</script>

<style scoped lang="less">
.in-from-ul {
  padding: 0 38px;
}

.box {
  padding: 20px 0 30px 0;
}

.in-from-li {
  margin-bottom: 28px;
  cursor: pointer;
}

.in-from-li.active {
  .icon:before {
    display: none;
  }

  .in-from-top {
    color: rgba(153, 153, 153, 1);
  }

  .in-from-text {
    color: rgba(153, 153, 153, 1);
  }
}

.in-from-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 52px;
  border-bottom: 1px solid rgba(228, 228, 231, 1);
  margin-bottom: 10px;
}

.in-from-left {
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 18px;
}

.in-from-right {
  color: rgba(161, 161, 170, 1);
  font-size: 12px;
}

.in-from-text {
  line-height: 25px;
  text-align: left;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
}

.icon:before {
  content: '';
  display: block;
  position: absolute;
  width: 6px;
  height: 6px;
  background: rgba(239, 68, 68, 1);
  border-radius: 50%;
  right: 0;
  border: 1px solid #fff;
}

.icon {
  position: relative;
  margin-right: 6px;

  img {
    width: 28px;
    display: block;
  }
}

/deep/.el-input__inner {
  height: 32px;
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pagination button {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pager li {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  border-right: 2px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #BD181E !important;
  color: rgba(255, 255, 255, 0.65) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/PersonalCenter/components/InformList.vue